module.exports = __webpack_public_path__ + "img/dgitem9.1e4cbe95.png";